import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, fetchClient, nullOn404, userApiClient } from '@/setup/api'

export type IGetCityQueryData = ApiResponseBody<'get', '/web/cities/{citySlug}'>['data']

export const getCityQueryOptions = (citySlug: string, locale: string) => {
    const init = {
        params: { path: { citySlug } },
        headers: { 'accept-language': locale },
    }

    // An unknown city slug is "no data", not a failure: callers render notFound().
    return nullOn404(
        userApiClient.queryOptions('get', '/web/cities/{citySlug}', init).queryKey,
        (signal) => fetchClient.GET('/web/cities/{citySlug}', { ...init, signal })
    )
}

export function useGetCityQuery(citySlug: string) {
    const locale = useLocale()

    return useQuery(getCityQueryOptions(citySlug, locale))
}
